import { Outlet, NavLink, useLocation } from 'react-router-dom';

export default function Automation() {
  const location = useLocation();
  const isIndex = location.pathname === '/automation' || location.pathname === '/automation/';

  const subPages = [
    { to: '/automation', label: 'Basic Automations', icon: '🔔', end: true },
    { to: '/automation/custom-reply', label: 'Custom Auto Reply', icon: '↩️' },
    { to: '/automation/workflows', label: 'Workflows', icon: '🔄' },
    { to: '/automation/ai-intent', label: 'AI Intent Matching', icon: '✨' },
    { to: '/automation/ai-agent', label: 'WhatsApp AI Agent', icon: '🤖' },
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginBottom: 16 }}>Automation</h2>

      {/* Sub Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 24, flexWrap: 'wrap' }}>
        {subPages.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            style={({ isActive }) => ({
              padding: '7px 16px',
              borderRadius: 20,
              textDecoration: 'none',
              fontSize: 13,
              fontWeight: isActive ? 600 : 500,
              border: isActive ? '1.5px solid #25D366' : '1.5px solid #e0e0e0',
              background: isActive ? '#e8fdf2' : '#fff',
              color: isActive ? '#128C7E' : '#555',
            })}
          >
            {item.icon} {item.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
